<div class="pt-md-3">
  <div class="mb-4">
    <app-additional-coverage-box
      [ctrl]="form.controls.isKundeSkipperVertragsHaftpflichtSelected"
      [customSwitchValues]="[false, true]"
      [icon]="'pi-id-card'"
      [id]="'hasHaftpflicht'"
      [text]="'bvs.calculator.hasHaftpflichtText'"
      [title]="'bvs.calculator.hasHaftpflichtTitle'"></app-additional-coverage-box>
  </div>

  @if (form.controls.isKundeSkipperVertragsHaftpflichtSelected.value) {
    <div class="mb-5">
      <app-additional-coverage-box-for-enum
        [ctrl]="form.controls.skipperHaftpflicht.controls.callidusSkipperVersicherungssummeKunde"
        [switchValues]="[CallidusSkipperVersicherungssummeKunde.Versicherungssumme5Mio, CallidusSkipperVersicherungssummeKunde.Versicherungssumme10Mio]"
        [icon]="'pi-shield'"
        [text]="'bvs.calculator.skipper.versicherungssummeText'"
        [title]="'bvs.calculator.skipper.versicherungssummeTitle'"></app-additional-coverage-box-for-enum>
    </div>
  }
</div>